import { PermissionEnum } from '../../../common/permissions/permissions.Enum';
import { getGroupPermissionFactory } from '../../../common/permissions/permissions.utils';
import { getUserManagementModuleName } from './user-management.permissions';

export class AccountsPermissions {
    static GroupName = `${getUserManagementModuleName()}.Accounts`;

    static getPermissions = getGroupPermissionFactory(AccountsPermissions.GroupName);

    static Permissions = {
        Create: AccountsPermissions.getPermissions(PermissionEnum.CREATE),
        Read: AccountsPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: AccountsPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: AccountsPermissions.getPermissions(PermissionEnum.UPDATE),
        Validation: AccountsPermissions.getPermissions('Validation'),
        AdminValidation: AccountsPermissions.getPermissions('AdminValidation'),

    };
}
